module.exports = __webpack_public_path__ + "static/media/login_image.803d188f.png";